import React, { useState, useEffect } from 'react';
import axios from 'axios';
import AddHearingForm from './AddHearingForm';
import EditHearingForm from './EditHearingForm';
import Hearings from './Hearings';

function MyHearings() {
  const [hearings, setHearings] = useState([]);
  const [showAddHearingForm, setShowAddHearingForm] = useState(false);
  const [showEditHearingForm, setShowEditHearingForm] = useState(false);
  const [editingHearingId, setEditingHearingId] = useState(null);

  useEffect(() => {
    fetchHearings();
  }, []);

  const fetchHearings = async () => {
    const token = localStorage.getItem("token");
    try {
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/hearings`,{
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      });
      
      setHearings(res.data);
    } catch (err) {
      console.error("Error fetching hearings:", err);
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6 text-white">Hearing Schedule</h1>

      <button
        onClick={() => setShowAddHearingForm(!showAddHearingForm)}
        className="mb-6 bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
      >
        {showAddHearingForm ? "Close Form" : "Add Hearing"}
      </button>

      {showAddHearingForm && (
        <AddHearingForm closeModal={() => setShowAddHearingForm(false)} onHearingAdded={fetchHearings} />
      )}

      {showEditHearingForm && (
        <EditHearingForm
          hearingId={editingHearingId}
          closeModal={() => setShowEditHearingForm(false)}
          onHearingUpdated={fetchHearings}
        />
      )}

      <Hearings
        hearings={hearings}
        onHearingDeleted={fetchHearings}
        onEditClick={(id) => {
          setEditingHearingId(id);
          setShowEditHearingForm(true);
        }}
      />
    </div>
  );
}

export default MyHearings;
